<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <el-date-picker
          class="box-header__date-picker"
          v-model="dateRange"
          type="daterange"
          range-separator="-"
          start-placeholder="С дд.мм.гггг"
          end-placeholder="По дд.мм.гггг"
          unlink-panels
          format="dd.MM.yyyy"
          size="mini"
          @change="loadLogic(true)"
          :picker-options="pickerOptions">
        </el-date-picker>

        <el-button class="box-header__button" size="mini" type="primary" icon="el-icon-notebook-2">Скачать Excel</el-button>
      </div>

      <template>
        <el-table :data="tableData" class="table">
          <el-table-column label="Начало">
            <template slot-scope="scope">
              {{ $root.dateIso(scope.row.registration_date) }}
            </template>
          </el-table-column>
          <el-table-column label="Окончание">
            <template slot-scope="scope">
              {{ $root.dateIso(scope.row.registration_date) }}
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="Номер"></el-table-column>
        </el-table>

        <el-pagination
          v-if="showPagination"
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size="pagination.per_page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          @current-change="loadLogic"
        ></el-pagination>

      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'StatisticsLight',
  data () {
    return {
      tableData: null,
      loading: false,
      errorLoadCard: false,
      User: {
        title: null,
        description: null
      },
      error: null,
      dateRange: false,
      pagination: null,
      pickerOptions: {
        shortcuts: [{
          text: '7 дней',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '30 дней',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '3 месяца',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  created () {
    this.loadLogic()
  },
  computed: {
    showPagination () {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else return false
    }
  },
  methods: {
    loadLogic () {
      this.loading = !!1
      const params = {
        params: {
          date_from: this.dateRange[0],
          date_to: this.dateRange[1]
        }
      }

      this.$api.statistics
        .getLight(params)
        .then((response) => {
          this.tableData = response.data.data
          if (response.data.meta) this.pagination = response.data.meta.pagination
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 1960px;
  margin: 0 auto;
}

.box-header {
  &__date-picker {
    max-width: 250px;
  }
}

.table {
  width: 100%;
  &__btn {
    margin: 5px;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination {
  margin-top: 10px;
  padding: 0;
}
</style>
